import { NodeProps } from '@xyflow/react'
import React from 'react'

import { useSwitchboardT } from '../../types'
import { text } from '../../utils/text'
import { BaseNode, nodePropsAreEqual } from './BaseNode'

export interface HangUpNodeProps extends NodeProps {
  onDelete?: () => void
  onDeleteNode?: (nodeId: string) => void

  showDeleteButton?: boolean
}

const HangUpNodeComponent: React.FC<HangUpNodeProps> = ({
  id,
  onDelete,
  onDeleteNode,
  showDeleteButton,
}) => {
  const t = useSwitchboardT()
  return (
    <BaseNode
      badgeColor="red"
      label={text(t, 'switchboard.nodeLabels.hang_up', 'HANG UP')}
      sourceHandlePosition={null}
      compact
      onDelete={onDelete}
      onDeleteNode={onDeleteNode}
      id={id}
      showDeleteButton={showDeleteButton}
      borderRadius="xl"
      headerPaddingX={6}
      headerPaddingY={4}
      customBadgeBg="transparent"
      customBadgeColor="fg.default"
      headerJustifyContent="center"
    />
  )
}

export const HangUpNode = React.memo(HangUpNodeComponent, nodePropsAreEqual)
